module.exports = __webpack_public_path__ + "static/img/plushie-frenzy.d0a2670.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plushie-frenzy.jpg
// module id = bjw5
// module chunks = 0